/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Typography, TableCell, TextField } from "@mui/material";
import { globalColors } from "../../themes/colors";

export const containerStyles = {
  p: 2,
  height: "100%",
  width: "100%",
  backgroundColor: "#f5f5f5",
  overflowY: "auto",
};

export const appBarStyles = {
  position: "static",
  color: "transparent",
  elevation: 0,
};

export const toolbarStyles = {
  px: 0,
  minHeight: "auto",
};

export const dividerStyles = {
  borderColor: "#e0e0e0",
};

export const filtersGridStyles = {
  backgroundColor: "#f5f5f8",
  justifyContent: "space-between",
  padding: 1,
  border: "1px solid #e0e0e0",
  mt: 2,
  mb: 2,
};

export const viewTypographyStyles = {
  color: "#666",
  fontSize: "0.875rem",
};

export const selectBaseStyles = {
  backgroundColor: "white",
  fontSize: "0.875rem",
  "& .MuiSelect-select": { py: "6px" },
  "&.MuiOutlinedInput-root": {
    height: "2.4rem",
    "&:hover fieldset": { borderColor: "#2b4fb9" },
    "&.Mui-focused fieldset": { borderColor: "#2b4fb9" },
  },
};

export const modalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 1,
  p: 4,
  maxHeight: 600,
  overflowX: "auto",
};

export const datePickerStyles = {
  maxWidth: 150,
  backgroundColor: "white",
  fontSize: "0.875rem",
  "& .MuiSelect-select": { py: "6px" },
  "& .MuiOutlinedInput-root": {
    height: "2.4rem",
    "&:hover fieldset": { borderColor: "#2b4fb9" },
    "&.Mui-focused fieldset": { borderColor: "#2b4fb9" },
  },
};

export const updateButtonBaseStyles = {
  fontSize: "0.875rem",
  textTransform: "none",
  fontWeight: 600,
  px: 2,
  border: "1px solid rgba(0,0,0,.12)",
  py: "6px",
};

export const tabsStyles = {
  borderBottom: "1px solid #e0e0e0",
  "& .MuiTabs-flexContainer": { gap: "20px" },
  "& .MuiTab-root": {
    color: "#666",
    fontSize: "0.875rem",
    minWidth: "auto",
    padding: "2px",
    minHeight: "40px",
    px: 0,
    "&:hover": { color: "black" },
  },
  "& .Mui-selected": {
    backgroundColor: "white",
    color: "black !important",
    fontWeight: 600,
    padding: "0px 16px",
  },
  "& .MuiTabScrollButton-root": {
    backgroundColor: "white",
    borderRadius: "40px",
    height: "40px",
  },
  "&.MuiTabs-root": {
    minHeight: 0,
  },
};

export const fontStyles = {
  fontSize: "0.875rem",
  color: "black !important",
  fontWeight: 600,
  marginTop: 4,
};

export const fontStyles2 = {
  fontSize: "0.875rem",
  color: "#666 !important",
  fontWeight: 200,
  marginTop: 4,
};

export const tableHeaderStyles = {
  py: 1,
  "&:last-child": { borderRight: 0 },
  fontSize: "14px",
  color: globalColors.tableHeader,
  fontWeight: 500,
  padding: "5px 5px 5px 15px",
  height: "40px",
  position: "relative",
};

export const tableSortLabelStyles = {
  '&:hover': {
    color: 'black',
  },
  '&.Mui-active': {
    color: "#black",
  },
  fontWeight: 500,
  fontSize: "14px",
  color: globalColors.tableHeader,
};

export const tableCellStyles = {
  backgroundColor: "#f5f5f5",
  py: 1,
  fontSize: "0.875rem",
  "&:last-child": { borderRight: 0 },
};

export const scrollbarStyles = {
  position: "sticky",
  bottom: 0,
  height: "var(--app-scrollbar-size)",
  overflowX: "auto",
  overflowY: "hidden",
  background: "transparent",
  zIndex: 20,
  width: "100%",
  mt: 0.5,
  "&::-webkit-scrollbar": {
    height: "var(--app-scrollbar-size)",
  },
  "&::-webkit-scrollbar-track": {
    background: "var(--app-scrollbar-track)",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "var(--app-scrollbar-thumb)",
    borderRadius: "999px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "var(--app-scrollbar-thumb-hover)",
  },
  scrollbarWidth: "thin",
  scrollbarColor: "var(--app-scrollbar-thumb) var(--app-scrollbar-track)",
}

export const StyledNoDataText = styled(Typography)({
  paddingLeft: 2,
  paddingTop: 2,
  fontSize: "0.875rem",
})

export const StyledTableCell = styled(TableCell)(({ width }) => ({
  padding: "5px 5px 5px 15px",
  height: "40px",
  width: `${width}px`,
  maxWidth: `${width}px`,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  color: globalColors.tableData,
}))

export const StyledSearchBar = styled(TextField)({
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #2b4fb9 !important'
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: '1px',
    borderRadius: '25px',
  },
  '& .MuiInputBase-root': {
    borderRadius: '25px',
    height: '2.4rem',
    paddingTop: '3px',
    fontSize: '15px',
    width: '253px !important',
    backgroundColor: 'white',
  },
})
